<template>
	<div>
		<ValidationDialog :ShowModal="ShowModal" :RouteUrl="RouteUrl" :DisplayMessage="DisplayMessage" @closeclicked="afterCloseHandled">
		</ValidationDialog>

		<SenderEmailUpdateDialog :ShowModal="showEmailUpdateModal" @onemailupdated="onEmailSubmitted">
		</SenderEmailUpdateDialog>

		<AfterLoginBannerDialog :ShowModal="showAfterLoginModal" :items="AfterLoginBannerCollection"
			@okclicked="afterOkHandled"></AfterLoginBannerDialog>

		<div class="notice-bar">
			<div class="container">
				<ul>
					<li>
						<h4>Verification</h4>
						<h4 class="detail">
							Email : {{userInfo.EmailAddressConfirmed == 'true' ? 'Yes' : 'No'}} | Phone : {{userInfo.PhoneNumberConfirmed == 'true'
              ? 'Yes' : 'No'}} | Identity : {{userInfo.UserKycStatus == 'VERIFIED' ? 'Yes' : 'No'}}
						</h4>
					</li>
					<li>
						<h4>Last login</h4>
						<h4 class="detail">{{userInfo.LastLoginDate}}</h4>
					</li>
					<li>
						<h4>IP Address</h4>
						<h4 class="detail">{{userInfo.IPAddress}}</h4>
					</li>
				</ul>
			</div>
		</div>

		<!-- eo notice bar -->

		<div class="main-header">
			<div class="container">
				<div class="whatsapp-icon-right">
					<a href="https://api.whatsapp.com/send?phone=60133404707&text=Hello_eRemit" target="_blank"><img src="/static/img/Whatsapplogo.png" height="50px"></a>
				</div>
				<div class="row">
					<div class="col-lg-6 bdl">
						<div class="transfer-order">
							<h4>Calculate your transfer order</h4>
							<div class="transfer-card">
								<b-tabs pills class="currency-converter">
									<b-tab :title="'Merchantrade'" @click="clearTabFilter()" active>
										<div class="transfer-amount">
											<div class="form-group">
												<label for>Transfer Amount</label>
												<div class="input-with-flag" style="width:100% !important">
													<div class="flag">
														<img src="/static/img/flags/my.png" alt />
														<h3>MYR</h3>
													</div>
													<input type="text" class="form-control" id="myrcurrency"
														v-model="vModel.PCurrency" placeholder="MYR" name="myrcurrency"
														v-only-numeric:decimal="" @keyup="onPAmountChange('transferamount')"
														maxlength="9" />
												</div>
											</div>
										</div>
										<div class="receive-amount">
											<div class="form-group">
												<label for>Receive Amount</label>

												<div class="select-country-input">
													<kendo-dropdownlist v-if="MirsCountryList != null"
														name="MirsCountry" ref="MirsCountry" class="form-control"
														v-model="vModel.CountryId" :data-text-field="'CountryName'"
														:data-value-field="'Id'" :option-label="'Select Country'"
														:auto-bind="true" :data-source="MirsCountryList"
														:data-value-primitive="true" @select="onMirsCountrySelect"
														@change="onMirsCountryChange"></kendo-dropdownlist>

													<kendo-dropdownlist name="MirsPayoutMode" ref="MirsPayoutMode"
														class="form-control" v-model="vModel.PaymentModeId"
														:option-label="'Select Payment Mode'" :auto-bind="true"
														:data-text-field="'Name'" :data-value-field="'Id'"
														:data-value-primitive="true" @change="onMirsPaymodeChange">
													</kendo-dropdownlist>

													<!-- <kendo-dropdownlist v-if="ExchangeRates != null"
														name='ExchangeRates' ref="ExchangeRates" class="form-control"
														:valueTemplate="itemTemplateCurrency" v-model="vModel.Currency"
														:template="itemTemplateCurrency"
														:option-label="'Select Currency'" :auto-bind="true"
														:data-source="ExchangeRates" :data-value-primitive="true">
                          </kendo-dropdownlist>-->

													<div class="input-with-flag" style="width:100% !important">
														<!-- <div class="flag">
															<img src="img/flags/my.png" alt=""/>
																<h3>MYR</h3>
                            </div>-->
														<input type="text" class="form-control" id="fcy"
															v-model="vModel.SCurrency" placeholder="FCY" name="fcy"
															v-only-numeric @keyup="onPAmountChange('')" maxlength="9" />
													</div>
												</div>
											</div>
										</div>
										<div class="transfer-notice">
											<h4>The current exchange rate is</h4>
											<h4 class="detail">
												1 MYR =
												{{vModel.SCurrency ? vModel.ExchangeRate? vModel.ExchangeRate.toFixed(4) : '':'' }} {{vModel.SCurrency ? vModel.CurrencyCode:''
                        }}
											</h4>
										</div>
									</b-tab>

									<b-tab :title="'Western Union'" @click="clearTabFilter()">
										<div class="transfer-amount">
											<div class="form-group">
												<label for>Transfer Amount</label>
												<div class="input-with-flag">
													<div class="flag">
														<img src="/static/img/flags/my.png" alt />
														<h3>MYR</h3>
													</div>
													<input type="text" class="form-control" id="myrcurrencywu"
														v-model="vModelWU.PCurrency" placeholder="MYR"
														name="myrcurrencywu" v-only-numeric:decimal=""
														@keyup="onWUPAmountChange('transferamount')" maxlength="9" />
												</div>
											</div>
										</div>
										<div class="receive-amount">
											<div class="form-group">
												<label for>Receive Amount</label>
												<div class="select-country-input">
													<kendo-dropdownlist v-if="CountryCollection != null"
														name="WUCountry" ref="WUCountry" class="form-control"
														v-model="vModelWU.CountryId" :data-text-field="'Text'"
														:data-value-field="'Id'" :option-label="'Select Country'"
														:auto-bind="true" :data-source="CountryCollection"
														:data-value-primitive="true" @change="onChangeCountryDropDown">
													</kendo-dropdownlist>

													<kendo-dropdownlist name="WUPayoutMode" ref="WUPayoutMode"
														class="form-control" v-model="vModelWU.PayoutModeId"
														:option-label="'Select Payment Mode'" :auto-bind="true"
														:data-text-field="'Name'" :data-value-field="'Id'"
														:data-value-primitive="true" @change="onChangeCWuPaymentMode">
													</kendo-dropdownlist>
												</div>

												<div class="select-country-input">
													<kendo-dropdownlist name="WUCurrency" ref="WUCurrency"
														class="form-control" :data-text-field="'Text'"
														:data-value-field="'Id'" v-model="vModelWU.CurrencyId"
														:option-label="'Select Currency'" :auto-bind="true"
														@change="onWuCurrencyChange()" :data-value-primitive="true">
													</kendo-dropdownlist>
													<div class="input-with-flag">
														<input type="text" class="form-control" id="fcywu"
															v-model="vModelWU.SCurrency" placeholder="FCY" name="fcywu"
															v-only-numeric @keyup="onWUPAmountChange('')"
															maxlength="9" />
													</div>
												</div>
											</div>
										</div>

										<div class="transfer-notice">
											<h4>The current exchange rate is</h4>
											<h4 class="detail">
												1 MYR =
												{{vModelWU.ExchangeRate == null || vModelWU.ExchangeRate == ''? '' : ((vModelWU.ExchangeRate == null ? '' : vModelWU.ExchangeRate) +" "+ (vModelWU.CurrencyCode? vModelWU.CurrencyCode:''))}}
											</h4>
										</div>
									</b-tab>

									<b-tab :title="'Send to eligible Visa Cards'" @click="clearTabFilter()">
										<div class="transfer-amount">
											<div class="form-group">
												<label for>Transfer Amount</label>
												<div class="input-with-flag">
													<div class="flag">
														<img src="/static/img/flags/my.png" alt />
														<h3>MYR</h3>
													</div>
													<input type="text" class="form-control" id="myrcurrencyvd"
														v-model="vModelVD.PCurrency" placeholder="MYR"
														name="myrcurrencyvd" v-only-numeric:decimal=""
														@keyup="onVDPAmountChange('transferamount')" maxlength="9" />
												</div>
											</div>
										</div>
										<div class="receive-amount">
											<div class="form-group">
												<label for>Receive Amount</label>
												<div class="select-country-input">
													<kendo-dropdownlist v-if="VDCountryCollection != null"
														name="VDCountry" ref="VDCountry" class="form-control"
														v-model="vModelVD.CountryId" :data-text-field="'Text'"
														:data-value-field="'Id'" :option-label="'Select Country'"
														:auto-bind="true" :data-source="VDCountryCollection"
														:data-value-primitive="true" @change="onVDCountrySelect">
													</kendo-dropdownlist>

													<kendo-dropdownlist name="VDPayoutMode" ref="VDPayoutMode"
														class="form-control" v-model="vModelVD.PayoutModeId"
														:option-label="'Select Payment Mode'" :auto-bind="true"
														:data-text-field="'Name'" :data-value-field="'Id'"
														:data-value-primitive="true" @change="onChangeVDPaymentMode">
													</kendo-dropdownlist>
												</div>

												<div class="select-country-input">
													<kendo-dropdownlist name="VDCurrency" ref="VDCurrency"
														class="form-control" :data-text-field="'Text'"
														:data-value-field="'Id'" v-model="vModelVD.CurrencyId"
														:option-label="'Select Currency'" :auto-bind="true"
														@change="onVDCurrencyChange" :data-value-primitive="true">
													</kendo-dropdownlist>
													<div class="input-with-flag">
														<input type="text" class="form-control" id="fcywu"
															v-model="vModelVD.SCurrency" placeholder="FCY" name="fcywu"
															v-only-numeric @keyup="onVDPAmountChange('')"
															maxlength="9" />
													</div>
												</div>
											</div>
										</div>

										<div class="transfer-notice">
											<h4>The current exchange rate is</h4>
											<h4 class="detail">
												1 MYR =
												{{vModelVD.ExchangeRate == null || vModelVD.ExchangeRate == ''? '' : ((vModelVD.ExchangeRate == null ? '' : vModelVD.ExchangeRate) +" "+ (vModelVD.CurrencyCode? vModelVD.CurrencyCode:''))}}
											</h4>
										</div>
									</b-tab>
								</b-tabs>
							</div>
						</div>
						<!-- eo transfer order -->
					</div>

					<div class="col-lg-6">
						<div class="recipient-form">
							<div class="recipient-card">
								<div class="select-person select-person-input">
									<form action>
										<div class="form-group">
											<label for>Who would you like to pay ?</label>
											<div class="input-group mb-3">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="fas fa-user"></i>
													</span>
												</div>
												<kendo-dropdownlist v-if="RecipientCollection != null"
													name="TransactionUrl" ref="kendoRecipient"
													class="form-control allreceipent" v-model="vModel.RecipientId"
													:data-value-field="'TransactionUrl'" :data-value-text="'FullName'"
													:valueTemplate="recipientValueTemplate" :template="itemTemplate"
													:option-label="'Please Select Recipient'" :auto-bind="true"
													:data-source="RecipientCollection" :data-value-primitive="true">
												</kendo-dropdownlist>
											</div>
										</div>
									</form>
								</div>
								<div class="recipient-submit" variant="default">
									<div class="add-recipient">
										<!-- <b-dropdown id="ddown-offset">
											<template slot="button-content">
												<i class="fas fa-plus"></i> New Recipient
											</template>
											<b-dropdown-item :to="'/recipient/merchantrade/add'"><img src="/static/img/icons/eremit-icon.png" height="25" width="25"> Merchantrade</b-dropdown-item>
											<b-dropdown-item :to="'/recipient/westernunion/add'"><img src="/static/img/icons/western-union-icon.png" height="25" width="25"> Western Union</b-dropdown-item>
                    </b-dropdown>-->
										<!-- <router-link :to="'/recipient/add'" class="btn button-white">
											<i class="fas fa-plus"></i> New Recipient
                    </router-link>-->
										<button type="button" class="btn button-white"
											@click.prevent="checkRecipientCount()">
											<i class="fas fa-plus"></i> New Recipient
										</button>
									</div>
									<div class="make-payment">
										<button class="btn button-red" type="button" @click="sendMoney">
											Make
											Payment
										</button>
									</div>
								</div>
							</div>
						</div>
						<!-- eo recipient form -->
					</div>
					<!-- eo col -->
				</div>
			</div>
		</div>
		<!-- eo main header -->

		<div class="main-section mgt-40">
			<div class="container">
				<div class="main-card">
					<div class="dashboard-tabs">
						<b-tabs pills>
							<b-tab active>
								<template v-slot:title>
									<img src="/static/img/icons/arrow-down-indicator-red.png" />Promotions
								</template>
								<div class="row promo_wrap_list">
									<div class="row" v-for="item in PromotionCollection"
										v-bind:key="item.PromotionCodeId">										
										<div class="col-lg-12">
											<div class="exchange-rate-image">
												<img :src="'api/image/promotion/'+item.Id" alt />
											</div>
										</div>
										<div class="col-lg-12">
											<h3 style="text-decoration: underline;">{{item.Title}}</h3>
										</div>
										<div class="col-lg-12">
											<p>Promo Period: <span style="color:red">{{item.StartDate}} - {{item.EndDate}}</span></p>
										</div>
										<div class="col-lg-12" v-if="item.HyperLink">
											<p>For more info please visit: </p>
											<p><a :href="item.HyperLink" target="_blank">{{item.HyperLink}}</a></p>
										</div>
										
										<div class="col-lg-12">
											<p v-html="item.Description"></p>
										</div>		
										<div class="col-lg-12">
											<hr><p><br></p>
										</div>								
									</div>
								</div>
							</b-tab>
							<b-tab>
								<!-- :title="tabTwo" -->
								<template v-slot:title>
									<img src="/static/img/icons/arrow-down-indicator-red.png" />Account activity
								</template>
								<table class="table table-striped table-bordered main-table table-responsive-md">
									<thead>
										<tr>
											<th scope="col">Transaction Reference</th>
											<th scope="col">Send Amount > Pay Amount</th>
											<th scope="col">Created On</th>
											<th scope="col">Status</th>
										</tr>
									</thead>
									<tbody>
										<tr :key="item.TransactionRefNo" v-for="item in RecentTransactionCollection">
											<td class="person-detail">
												<router-link :to="'/transaction/detail/'+item.TransactionRefNo"
													class="text-underline">
													<img :src="item.TransactionChannelImageUrl" width="25"
														height="25" />
													{{item.TransactionRefNo}}
												</router-link>

												<br />
												<span class="name">{{item.FullName.toUpperCase()}}</span>
											</td>

											<td>MYR {{item.SendAmount}} > {{item.PCurrency}} {{item.PayoutAmount}}</td>
											<td>
												<span class="date-time">{{item.CreatedDate}}</span>
											</td>
											<td>
												<span :class="badgeColor(item.StatusId)">{{item.CustomerStatus}}</span>
											</td>
										</tr>
									</tbody>
								</table>
							</b-tab>
							<b-tab>
								<!-- :title="tabThird" -->
								<template v-slot:title>
									<img src="/static/img/icons/arrow-down-indicator-red.png" />Notifications
								</template>
								<table class="table table-striped table-bordered main-table table-responsive-md">
									<thead>
										<tr>
											<th scope="col">Date</th>
											<th scope="col">Message</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="item in NotificationCollection">
											<td>
												<span class="date-time">{{item.CreatedDate}}</span>
											</td>
											<td>
												<div v-if="item.NotificationType === 1">
													<router-link to="/transaction" class="text-underline">
														<i class="icon-envelope"></i>
														{{item.Message}}
													</router-link>
													<a style="color:black;" target="_blank"
														href="http://www.eremit.com.my/download/reprocess.pdf">
														(how to
														reprocess?)
													</a>
												</div>
												<div v-else-if="item.NotificationType === 2">
													<router-link to="/transaction" class="text-underline">
														<i class="icon-envelope"></i>
														{{item.Message}}
													</router-link>
													<a style="color:black;" target="_blank"
														href="http://www.eremit.com.my/download/refund.pdf">
														(how to
														refund?)
													</a>
												</div>
												<div v-else-if="item.NotificationType === 3">
													<router-link to="/transaction" class="text-underline"
														style="color:black">
														<i class="icon-envelope"></i>
														{{item.Message}}
													</router-link>
												</div>
												<div v-else v-html="item.Message.replace(/\n/g, '<br />')"></div>
											</td>
										</tr>
									</tbody>
								</table>
								<!-- <ul class="notification-wrapper">
										<li v-for="item in NotificationCollection" v-html="item"></li>
                </ul>-->
							</b-tab>
						</b-tabs>

						<!-- eo tab content -->
					</div>
				</div>
				<!-- eo main card -->
			</div>
			<!-- eo container -->
		</div>
		<!-- eo main section -->

		<!-- eo container -->
	</div>
</template>
<script>
	import Base from "../shared/Base.vue";
	import ListService from "../services/list";
	import CommonService from "../services/common";
	import ValidationDialog from "../shared/ValidationDialog.vue";
	import SenderEmailUpdateDialog from "../shared/SenderEmailUpdate.vue";
	import AfterLoginBannerDialog from "../shared/AfterLoginBanner.vue";
	import AfterLoginInsureBanner from "../shared/AfterLoginInsureBanner.vue"
	export default {
		name: "Dashboard",
		extends: Base,
		components: {
			ValidationDialog,
			SenderEmailUpdateDialog,
			AfterLoginBannerDialog,
			AfterLoginInsureBanner
		},
		beforeRouteEnter(to, from, next) {
			var promises = [];
			promises.push(
				ListService.get("list/exchangerate"),
				ListService.get("transaction/recent/5"),
				ListService.get("recipient/information"),
				ListService.get("notification/dashboard"),
				ListService.get("list/westernunion/country"),
				ListService.get("v2/dashboard/initial"),
				ListService.get("list/banner/afterlogin/3"),
				ListService.get("list/promotion/all"),
			);
			Promise.all(promises).then((response) => {
				next((p) => {
					p.ExchangeRateCollection = response[0].body;
					p.RecentTransactionCollection = response[1].body;
					p.RecipientCollection = response[2].body;
					console.log('RecipientCollection',p.RecipientCollection)
					CommonService.setStorage("RecipientCollection", response[2].body);
					p.NotificationCollection = response[3].body;
					// p.CountryCollection = response[4].body;
					let mirsCntrylist = response[5].body;
					p.CountryCollection = mirsCntrylist.Countries.filter((x) =>
						x.WesternUnionActive && x.PaymentNetworks.filter((y) => y.Id == 2)
					); 
					console.log(p.CountryCollection);

					p.VDCountryCollection = mirsCntrylist.Countries.filter((x) =>
						x.PaymentNetworks.filter((y) => y.Id == 3)
					);
					console.log(p.VDCountryCollection);

					p.MirsCountryList = mirsCntrylist.Countries.filter(
						(x) => x.MirsActive && x.PaymentNetworks.filter((y) => y.Id == 1)
					);
					var list = [];
					p.ExchangeRateCollection.forEach(function (element) {
						list.push({
							Id: element.ExchangeRateId,
							Text: element.CurrencyCode,
							ExchangeRate: element.ExchangeRate,
							CurrencyCode: element.CurrencyCode,
							FlagCode: element.FlagCode,
						});
					});

					p.ExchangeRates = list;

					if (response[6].body && response[6].body.length > 0) {
						if (window.bannersToShow == undefined) window.bannersToShow = true;
						else window.bannersToShow = false;
					}

					p.AfterLoginBannerCollection = response[6].body;
					p.PromotionCollection = response[7].body;
				});
			});
		},

		created() {
			this.userInfo = CommonService.getUserInfo();
			this.AddressValidationCheck = CommonService.getUserAddressValidation();
			this.employeeIndustryCheck = CommonService.getEmployeeIndustryCheck();

		},
		
		mounted() {
			this.ShowModal = false;
			if (!this.employeeIndustryCheck.IsValid) {
				this.ShowModal = true;
				this.RouteUrl = "/profile";
				this.DisplayMessage = this.employeeIndustryCheck.DisplayMessage;
			} else {				
				setTimeout(() => {					
					if (window.bannersToShow) {
						this.showAfterLoginModal = window.bannersToShow;
					}
					
				}, 1000);

				setTimeout(() => {
						this.showAfterLoginInsureModal = true;
				}, 1000);

			}
			CommonService.removeStorage("carryModel");
			CommonService.removeStorage("RecipientCollection");
		},
		data() {
			return {
				tabOne:
					'<img src="/static/img/icons/arrow-down-indicator-red.png" alt=""/>Promotions',
				tabTwo:
					'<img src="/static/img/icons/arrow-down-indicator-red.png" alt=""/>Account activity',
				tabThird:
					'<img src="/static/img/icons/arrow-down-indicator-red.png" alt=""/>Notifications',
				userInfo: null,
				ExchangeRates: null,
				ExchangeRateCollection: [],
				RecentTransactionCollection: [],
				NotificationCollection: [],
				RecipientCollection: null,
				CountryCollection: null,
				VDCountryCollection: null,
				ClassBadge: {
					"badge-yellow": true,
				},
				employeeIndustryCheck:null,
				PayoutModeCollection: null,
				WUCurrencyCollection: null,
				// itemTemplate: `# if( data.PayoutModeId == 2 || data.PayoutModeId == 97) { #
				//             <div class="m-b-sm m-t-sm ddl-wrap" style="width:100%"><p class="recipient-wrap"><img src="#:data.TransactionChannelImageUrl#" height="25" width="25"> #:data.Fullname#</p><p class="img-wrap"><img src="static/img/flags/#:data.FlagCode#.png"  /><span>#:data.CountyName#<br/>#:data.PayoutMode#</span></p></div>;
				// 				# } #
				// 				# else if (data.PayoutModeId == 21) { #
				// 					<div class="m-b-sm m-t-sm ddl-wrap" style="width:100%"><p class="recipient-wrap"><img src="#:data.TransactionChannelImageUrl#" height="25" width="25"> #:data.Fullname#</p><p class="img-wrap"><img src="static/img/flags/#:data.FlagCode#.png"  /><span>#:data.PayoutMode#<br/>#:data.AccountNumber#</span></p></div>;
				// 				# } #
				// 				# else { #
				// 					<div class="m-b-sm m-t-sm ddl-wrap" style="width:100%"><p class="recipient-wrap"><img src="#:data.TransactionChannelImageUrl#" height="25" width="25"> #:data.Fullname#</p><p class="img-wrap"><img src="static/img/flags/#:data.FlagCode#.png"  /><span>#:data.AgentOrBankName#<br/>#:data.AccountNumber#</span></p></div>;
				// 				#} #`,
				recipientValueTemplate:
					'<img src="#:data.TransactionChannelImageUrl#" height="25" width="25">&nbsp;<span>#:data.Fullname#</span>',
				itemWUTemplateCurrency:
					'<img src="static/img/flags/#:data.Code#.png" /><span class="currencyWrappers-medium ">#:data.Text#</span>',
				itemTemplateCurrency:
					'<img src="static/img/flags/#:data.FlagCode#.png" /><span class="currencyWrappers">#:data.CurrencyCode#</span>',

				MirsCountryList: null,
				MirsSelectedCountryData: {},
				MirsSelectedCountryPaymentMode: [],
				vModel: {
					RecipientId: null,
					ExchangeRate: null,
					SCurrency: null,
					PCurrency: null,
					Currency: null,

					CurrencyCode: null,
					CountryId: null,
					CurrencyId: null,
					PaymentModeId: null,
					PaymentNetworkId: 1,
					TransferFee: 0.0,
				},
				vModelWU: {
					CountryId: null,
					PayoutModeId: null,
					CurrencyId: null,
					SCurrency: null,
					PCurrency: null,
					Currency: null,
					ExchangeRate: null,
					PaymentNetworkId: 2,
					CurrencyCode: "",
				},
				vModelVD: {
					CountryId: null,
					PayoutModeId: null,
					CurrencyId: null,
					SCurrency: null,
					PCurrency: null,
					Currency: null,
					ExchangeRate: null,
					PaymentNetworkId: 3,
					CurrencyCode: "",
				},
				WuPayoutModeList: [],
				VDPayoutModeList : [],
				AddressValidationCheck: {
					IsValid: true,
				},
				ShowModal: false,
				RouteUrl: null,
				DisplayMessage: "",
				showEmailUpdateModal: false,
				showBeneModal: false,
				showAfterLoginModal: false,
				showAfterLoginInsureModal: false,
				bannersToShow: false,
				AfterLoginBannerCollection: null,
				PromotionCollection: null,
				CarryModel:{
					PaymentNetworkId:0,
					CountryId:0,
					PaymentModeId:0,
					PayoutCurrencyId:0,
					SendAmount:0,
					PayAmount:0,
					IsLocalCurrencyKeyIn: false,
					ExchangeRate: 0,
					IsStepOne: false
				}
			};
		},
		watch: {
			// "vModel.Currency": function (val) {
			// 	this.vModel.ExchangeRate = val.ExchangeRate;
			// 	let amount = (
			// 		parseFloat(val.ExchangeRate) *
			// 		parseFloat(this.vModel.PCurrency)
			// 	).toFixed(2);
			// 	this.vModel.SCurrency = isNaN(amount) ? "" : amount;
			// }
		},
		methods: {
			onWuCurrencyChange() {
				setTimeout(() => {
					this.vModelWU.Currency = null;
					this.vModelWU.SCurrency = null;
					if (this.vModelWU.CurrencyId) {
						this.getWuRate();
						this.getRecipientListByFilter("WU",this.vModelWU.CountryId,this.vModelWU.PayoutModeId, this.vModelWU.CurrencyId);

						// var selectedCountry = this.CountryCollection.filter(s => {
						// 	return s.Id == this.vModelWU.CountryId;
						// })[0];

						// var currency = selectedCountry.Currencies.filter(s => {
						// 	return s.Id == this.vModelWU.CurrencyId;
						// })[0];

						// this.$http.post("westernunion/exchangerate", {
						// 	DestinationCountryCd: selectedCountry.Code,
						// 	DestinationCurrencyCd: currency.Code,
						// 	DeliveryService: ""

						// }).then(
						// 	response => {
						// 		this.vModelWU.ExchangeRate = response.body;
						// 		this.vModelWU.Currency = currency.Code;
						// 		this.onWUPAmountChange();
						// 	},
						// 	error => {

						// 	}
						// );
					}else{
						this.resetStorage();
					}
				}, 100);
				var dropDownList = this.$refs.WUCurrency.kendoWidget();
				var selectedVlaue = dropDownList.value();
				this.setCarryModel(this.vModelWU.PaymentNetworkId,this.vModelWU.CountryId, this.vModelWU.PayoutModeId, selectedVlaue);

			},
			onChangeCountryDropDown() {
				this.WuPayoutModeList = [];
				this.$refs.WUPayoutMode.kendoWidget().setDataSource([]);
				this.$refs.WUCurrency.kendoWidget().setDataSource([]);
				this.vModelWU.SCurrency = null;
				this.vModelWU.PCurrency = null;
				this.vModelWU.Currency = null;
				this.vModelWU.CurrrencyId = null;
				this.vModelWU.PayoutModeId = null;
				this.vModelWU.Currency = null;
				this.vModelWU.ExchangeRate = "";
				this.vModelWU.CurrencyCode = "";
				setTimeout(() => {
					if (this.vModelWU.CountryId) {
						var selectedCountry = this.CountryCollection.filter((s) => {
							return s.Id == this.vModelWU.CountryId;
						})[0];
						// this.$refs.WUPayoutMode.kendoWidget().setDataSource(selectedCountry.PaymentMethods);
						// this.$refs.WUCurrency.kendoWidget().setDataSource(selectedCountry.Currencies);
						this.WuPayoutModeList = selectedCountry.PaymentNetworks.filter(
							(x) => x.Id == 2
						)[0].PayoutModes;
						console.log(this.WuPayoutModeList);
						this.$refs.WUPayoutMode.kendoWidget().setDataSource([
							...this.WuPayoutModeList,
						]);
					}
				}, 50);
				this.clearTabFilter();
			},
			onChangeCWuPaymentMode(e) {
				this.$refs.WUCurrency.kendoWidget().setDataSource([]);
				this.vModelWU.CurrencyId = null;
				setTimeout(() => {
					if (this.vModelWU.PayoutModeId) {
						this.$refs.WUCurrency.kendoWidget().setDataSource(
							this.WuPayoutModeList[0].Currencies
						);
					}else{
						this.vModelWU.SCurrency = 0.0;
						this.vModelWU.ExchangeRate = 0.0;
						this.vModelWU.TransferFee = 0.0;
					}
				}, 50);
				this.resetStorage();
			},
			onWUPAmountChange(item) {
				let self = this;
				// if (self.vModelWU.Currency != null || self.vModelWU.Currency != '') {
				// 	setTimeout(() => {
				// 		// let amount = (
				// 		// 	parseFloat(this.vModelWU.ExchangeRate) *
				// 		// 	parseFloat(this.vModelWU.PCurrency)
				// 		// ).toFixed(2);

				// 		// this.vModelWU.SCurrency = isNaN(amount) ? "" : amount;
				// 		self.getWuRate();
				// 	}, 100);
				// }

				if (item == "transferamount") {
					if (
						isNaN(this.vModelWU.PCurrency) ||
						!this.vModelWU.PCurrency ||
						parseFloat(this.vModelWU.PCurrency) <= 0
					)
						return;
					this.vModelWU.IsLocalCurrencyKeyIn = true;
				} else {
					if (
						isNaN(this.vModelWU.SCurrency) ||
						!this.vModelWU.SCurrency ||
						parseFloat(this.vModelWU.SCurrency) <= 0
					)
						return;
					this.vModelWU.IsLocalCurrencyKeyIn = false;
				}
				setTimeout(() => {
					self.getWuRate();
				}, 1000);
				this.setCarryModelAmount(this.vModelWU.PCurrency,this.vModelWU.SCurrency, this.vModelWU.IsLocalCurrencyKeyIn, this.vModelWU.ExchangeRate);

			},
			onPAmountChange(item) {
				let self = this;
				if (item == "transferamount") {
					if (
						isNaN(this.vModel.PCurrency) ||
						!this.vModel.PCurrency ||
						parseFloat(this.vModel.PCurrency) <= 0
					)
						return;
					this.vModel.IsLocalCurrencyKeyIn = true;
				} else {
					if (
						isNaN(this.vModel.SCurrency) ||
						!this.vModel.SCurrency ||
						parseFloat(this.vModel.SCurrency) <= 0
					)
						return;
					this.vModel.IsLocalCurrencyKeyIn = false;
				}
				setTimeout(() => {
					self.getMirsRate();
				}, 1000);
			},
			getMirsRate() {
				let self = this;
				console.log(this.vModel.PaymentModeId);
				if (
					!this.vModel.CountryId ||
					!this.vModel.CurrencyId ||
					!this.vModel.PaymentModeId
				)
					return;
				if (this.vModel.IsLocalCurrencyKeyIn) {
					if (
						isNaN(this.vModel.PCurrency) ||
						!this.vModel.PCurrency ||
						parseFloat(this.vModel.PCurrency) <= 0
					)
						return;
				} else {
					if (
						isNaN(this.vModel.SCurrency) ||
						!this.vModel.SCurrency ||
						parseFloat(this.vModel.SCurrency) <= 0
					)
						return;
				}
				// setTimeout(() => {
				self.$http
					.post("v2/transaction/exchangerate", {
						CountryId: this.vModel.CountryId,
						PaymentNetworkId: this.vModel.PaymentNetworkId,
						PaymentModeId: this.vModel.PaymentModeId,
						CurrencyId: this.vModel.CurrencyId,
						SendAmount: this.vModel.PCurrency ? this.vModel.PCurrency : 0,
						PayAmount: this.vModel.SCurrency ? this.vModel.SCurrency : 0,
						IsLocalCurrencyKeyIn: this.vModel.IsLocalCurrencyKeyIn,
					})
					.then((res) => {
						self.vModel.ExchangeRate = res.body.ExchangeRate;
						self.vModel.TransferFee = res.body.TransferFee;
						self.vModel.CurrencyCode = res.body.DestinationCurrency;
						if (self.vModel.IsLocalCurrencyKeyIn) {
							self.vModel.SCurrency = parseFloat(res.body.PayAmount).toFixed(2);
						} else {
							self.vModel.PCurrency = parseFloat(res.body.SendAmount).toFixed(2);
						}
						this.setCarryModelAmount(this.vModel.PCurrency, this.vModel.SCurrency, self.vModel.IsLocalCurrencyKeyIn, self.vModel.ExchangeRate);

					});

				// }, 100);
			},
			getWuRate() {
				let self = this;
				if (
					!this.vModelWU.CountryId ||
					!this.vModelWU.CurrencyId ||
					!this.vModelWU.PayoutModeId
				)
					return;

				if (this.vModelWU.IsLocalCurrencyKeyIn) {
					if (
						isNaN(this.vModelWU.PCurrency) ||
						!this.vModelWU.PCurrency ||
						parseFloat(this.vModelWU.PCurrency) <= 0
					)
						return;
				} else {
					if (
						isNaN(this.vModelWU.SCurrency) ||
						!this.vModelWU.SCurrency ||
						parseFloat(this.vModelWU.SCurrency) <= 0
					)
						return;
				}
				// setTimeout(() => {
				self.$http
					.post("v2/transaction/exchangerate", {
						CountryId: this.vModelWU.CountryId,
						PaymentNetworkId: this.vModelWU.PaymentNetworkId,
						PaymentModeId: this.vModelWU.PayoutModeId,
						CurrencyId: this.vModelWU.CurrencyId,
						SendAmount: this.vModelWU.PCurrency ? this.vModelWU.PCurrency : 0,
						PayAmount: this.vModelWU.SCurrency ? this.vModelWU.SCurrency : 0,
						IsLocalCurrencyKeyIn: this.vModelWU.IsLocalCurrencyKeyIn,
					})
					.then((res) => {
						self.vModelWU.ExchangeRate = res.body.ExchangeRate;
						self.vModelWU.TransferFee = res.body.TransferFee;
						self.vModelWU.CurrencyCode = res.body.DestinationCurrency;
						if (self.vModelWU.IsLocalCurrencyKeyIn) {
							self.vModelWU.SCurrency = parseFloat(res.body.PayAmount).toFixed(2);
						} else {
							self.vModelWU.PCurrency = parseFloat(res.body.SendAmount).toFixed(
								2
							);
						}
						this.setCarryModelAmount(this.vModelWU.PCurrency, this.vModelWU.SCurrency,self.vModelWU.IsLocalCurrencyKeyIn, this.vModelWU.ExchangeRate);

					});
				// }, 100);
			},
			getVdRate() {
				let self = this;
				if (
					!this.vModelVD.CountryId ||
					!this.vModelVD.CurrencyId ||
					!this.vModelVD.PayoutModeId
				)
					return;

				if (this.vModelVD.IsLocalCurrencyKeyIn) {
					if (
						isNaN(this.vModelVD.PCurrency) ||
						!this.vModelVD.PCurrency ||
						parseFloat(this.vModelVD.PCurrency) <= 0
					)
						return;
				} else {
					if (
						isNaN(this.vModelVD.SCurrency) ||
						!this.vModelVD.SCurrency ||
						parseFloat(this.vModelVD.SCurrency) <= 0
					)
						return;
				}
				// setTimeout(() => {
				self.$http
					.post("v2/transaction/exchangerate", {
						CountryId: this.vModelVD.CountryId,
						PaymentNetworkId: this.vModelVD.PaymentNetworkId,
						PaymentModeId: this.vModelVD.PayoutModeId,
						CurrencyId: this.vModelVD.CurrencyId,
						SendAmount: this.vModelVD.PCurrency ? this.vModelVD.PCurrency : 0,
						PayAmount: this.vModelVD.SCurrency ? this.vModelVD.SCurrency : 0,
						IsLocalCurrencyKeyIn: this.vModelVD.IsLocalCurrencyKeyIn,
					})
					.then((res) => {
						self.vModelVD.ExchangeRate = res.body.ExchangeRate;
						self.vModelVD.TransferFee = res.body.TransferFee;
						self.vModelVD.CurrencyCode = res.body.DestinationCurrency;
						if (self.vModelVD.IsLocalCurrencyKeyIn) {
							self.vModelVD.SCurrency = parseFloat(res.body.PayAmount).toFixed(2);
						} else {
							self.vModelVD.PCurrency = parseFloat(res.body.SendAmount).toFixed(
								2
							);
						}
						this.setCarryModelAmount(this.vModelVD.PCurrency, this.vModelVD.SCurrency, self.vModelVD.IsLocalCurrencyKeyIn, self.vModelVD.ExchangeRate);
					});
				// }, 100);
			},

			onSAmountChange: function (e) {
				this.vModel.ExchangeRate = this.vModel.Currency.ExchangeRate;
				let amount = (
					parseFloat(this.vModel.SCurrency) / parseFloat(this.vModel.ExchangeRate)
				).toFixed(2);

				this.vModel.PCurrency = isNaN(amount) ? "" : amount;
			},
			badgeColor: function (statusid) {
				var color = {
					"badge-yellow": true,
				};
				switch (statusid) {
					case 1:
					case 2:
					case 3:
					case 4:
					case 6:
					case 7:
					case 8:
					case 14:
					case 15:
						color = {
							"badge-yellow": true,
						};
						break;
					case 5:
						color = {
							"badge-green": true,
						};
						break;
					case 9:
					case 11:
					case 12:
					case 19:
					case 20:
					case 21:
						color = {
							"badge-red": true,
						};
						break;

					case 10:
					case 13:
						color = {
							"badge-grey": true,
						};
						break;
				}

				return color;
			},
			sendMoney: function () {
				var self = this;
				if (self.vModel.RecipientId) {
					self.recipient = self.RecipientCollection.filter(
						(x) => x.TransactionUrl == self.vModel.RecipientId
					)[0];
					if (self.recipient) {
						var model = {
							PayoutModeId: self.recipient.PayoutModeId,
							BeneficiaryId: self.recipient.BeneficiaryId,
						};
						window.Vue.$http.post("transaction/beneficiary/isvalid", model).then(
							(response) => {
								if (response.body) {
									if (
										response.body.IsSenderEmailRequired &&
										response.body.IsValid
									) {
										self.showEmailUpdateModal = true;
									} else if (
										response.body.IsSenderEmailRequired &&
										!response.body.IsValid
									) {
										self.showEmailUpdateModal = true;
										self.showBeneModal = true;
										self.DisplayMessage = response.body.DisplayMessage;
										self.RouteUrl =
											self.recipient.PayoutModeId == 97 ||
												self.recipient.PayoutModeId == 98
												? "/recipient/westernunion/edit/" +
												self.recipient.BeneficiaryId
												: "/recipient/merchantrade/edit/" +
												self.recipient.PayoutModeId +
												"/" +
												self.recipient.BeneficiaryId;
									} else if (
										!response.body.IsSenderEmailRequired &&
										!response.body.IsValid
									) {
										self.ShowModal = true;
										self.DisplayMessage = response.body.DisplayMessage;
										self.RouteUrl =
											self.recipient.PayoutModeId == 97 ||
												self.recipient.PayoutModeId == 98
												? "/recipient/westernunion/edit/" +
												self.recipient.BeneficiaryId
												: "/recipient/merchantrade/edit/" +
												self.recipient.PayoutModeId +
												"/" +
												self.recipient.BeneficiaryId;
									} else if (response.body.IsWUtxnNotAllowed){
										kendo.alert(response.body.DisplayMessage);
									} else {
										window.Vue.$router.push(this.vModel.RecipientId);
									}
								}
							},
							(error) => { }
						);
					}
				}
			},
			pullpromotion: function () { },

			checkRecipientCount() {
				window.Vue.$http.get("v2/recipient/count").then(
					(response) => {
						this.$router.push("/recipient/add");
					},
					(error) => { }
				);
			},

			onMirsCountrySelect(e) {
				debugger
				if (this.vModel.CountryId == e.dataItem.Id) {
					return false;
				}
				this.$refs.MirsPayoutMode.kendoWidget().setDataSource([]);
				this.SelectedCountryData = {};
				this.SelectedCountryPaymentMode = [];
				this.SelectedCountryData = e.dataItem;
				let payoutmodeList = [];
				if (e.dataItem.Id) {
					payoutmodeList = this.SelectedCountryData.PaymentNetworks.filter(
						(x) => x.Id == 1
					)[0].PayoutModes;
					this.SelectedCountryPaymentMode = [...payoutmodeList];
					this.$refs.MirsPayoutMode.kendoWidget().setDataSource(
						this.SelectedCountryPaymentMode
					);
				}
				this.resetStorage();
				this.initMirsViewModelValue(this.SelectedCountryData);
				//
			},
			onMirsCountryChange(e) {
				console.log(e);
			},
			initMirsViewModelValue(obj) {
				(this.vModel.CountryId = obj.Id), (this.vModel.CurrencyCode = "");
				this.vModel.CurrencyId = obj.CurrencyId;
				this.vModel.PCurrency = 0.0;
				this.vModel.SCurrency = 0.0;
				this.vModel.ExchangeRate = 0.0;
				this.vModel.TransferFee = 0.0;
				this.vModel.PaymentModeId = 0;
				this.vModel.PaymentNetworkId = 1;
			},
			onMirsPaymodeChange(e) {
				this.vModel.PaymentModeId = e.sender.value();

				if (e.sender.value()) {
					this.getRecipientListByFilter("MTA",this.vModel.CountryId,this.vModel.PaymentModeId, 0);
					this.vModel.SCurrency = 0.0;
					this.vModel.ExchangeRate = 0.0;
					this.vModel.TransferFee = 0.0;
					this.getMirsRate();
					this.setCarryModel(this.vModel.PaymentNetworkId,this.vModel.CountryId, this.vModel.PaymentModeId, this.vModel.CurrencyId);
				}else{
					this.vModel.SCurrency = 0.0;
					this.vModel.ExchangeRate = 0.0;
					this.vModel.TransferFee = 0.0;
					this.resetStorage();
				}

			},

			itemTemplate: function (data) {
				if (data.PayoutModeId == 2 || data.PayoutModeId == 97) {
					return (
						'<div class="m-b-sm m-t-sm ddl-wrap" style="width:100%"><p class="recipient-wrap"><img src="' +
						kendo.htmlEncode(data.TransactionChannelImageUrl) +
						'" height="25" width="25">' +
						kendo.htmlEncode(data.Fullname) +
						'</p><p class="img-wrap"><img src="static/img/flags/' +
						kendo.htmlEncode(data.FlagCode) +
						'.png"  /><span>' +
						kendo.htmlEncode(data.CountyName) +
						"<br/>" +
						kendo.htmlEncode(data.PayoutMode) +
						"</span></p></div>"
					);
				} else if (data.PayoutModeId == 21) {
					return (
						'<div class="m-b-sm m-t-sm ddl-wrap" style="width:100%"><p class="recipient-wrap"><img src="' +
						kendo.htmlEncode(data.TransactionChannelImageUrl) +
						'" height="25" width="25">' +
						kendo.htmlEncode(data.Fullname) +
						'</p><p class="img-wrap"><img src="static/img/flags/' +
						kendo.htmlEncode(data.FlagCode) +
						'.png"  /><span>' +
						kendo.htmlEncode(data.PayoutMode) +
						"<br/>" +
						kendo.htmlEncode(data.AccountNumber) +
						"</span></p></div>"
					);
				} else if (data.PayoutModeId == 22) {
					return (
						'<div class="m-b-sm m-t-sm ddl-wrap" style="width:100%"><p class="recipient-wrap"><img src="' +
						kendo.htmlEncode(data.TransactionChannelImageUrl) +
						'" height="25" width="25">' +
						kendo.htmlEncode(data.Fullname) +
						'</p><p class="img-wrap-alipay"><img src="static/img/flags/' +
						kendo.htmlEncode(data.FlagCode) +
						'.png"  /><span>' +
						kendo.htmlEncode(data.PayoutMode) +
						"<br/>" +
						kendo.htmlEncode(data.AccountNumber) +
						"</span></p></div>"
					);
				} else {
					if (data.AgentOrBankName) {
						return (
							'<div class="m-b-sm m-t-sm ddl-wrap" style="width:100%"><p class="recipient-wrap"><img src="' +
							kendo.htmlEncode(data.TransactionChannelImageUrl) +
							'" height="25" width="25">' +
							kendo.htmlEncode(data.Fullname) +
							'<p class="img-wrap"><img src="static/img/flags/' +
							kendo.htmlEncode(data.FlagCode) +
							'.png"  /></p><div style="display: table"><div style="display: table-row">' +
							kendo.htmlEncode(data.AgentOrBankName) +
							'</div><div style="display: table-row">' +
							kendo.htmlEncode(data.AccountNumber) +
							"</div></div></div>"
						);
					} else {
						return (
							'<div class="m-b-sm m-t-sm ddl-wrap" style="width:100%"><p class="recipient-wrap"><img src="' +
							kendo.htmlEncode(data.TransactionChannelImageUrl) +
							'" height="25" width="25">' +
							kendo.htmlEncode(data.Fullname) +
							'</p><p class="img-wrap"><img src="static/img/flags/' +
							kendo.htmlEncode(data.FlagCode) +
							'.png"  /><span>' +
							kendo.htmlEncode(data.PayoutMode) +
							"<br/>" +
							kendo.htmlEncode(data.AccountNumber) +
							"</span></p></div>"
						);
					}
				}
			},

			onEmailSubmitted() {
				var self = this;
				if (self.showBeneModal) self.ShowModal = self.showBeneModal;
				else window.Vue.$router.push(self.vModel.RecipientId);
			},

			afterOkHandled(value) {
				this.showAfterLoginModal = value;
			},
			afterCloseHandled(value)
			{
				this.ShowModal = value;
			},
			afterOkInsureHandled(value) {
				this.showAfterLoginInsureModal = value;
			},

			onVDCountrySelect(e){
				this.VDPayoutModeList = [];
				this.$refs.VDPayoutMode.kendoWidget().setDataSource([]);
				this.$refs.VDCurrency.kendoWidget().setDataSource([]);
				this.vModelVD.SCurrency = null;
				this.vModelVD.PCurrency = null;
				this.vModelVD.Currency = null;
				this.vModelVD.CurrrencyId = null;
				this.vModelVD.PayoutModeId = null;
				this.vModelVD.Currency = null;
				this.vModelVD.ExchangeRate = "";
				this.vModelVD.CurrencyCode = "";
				setTimeout(() => {
					if (this.vModelVD.CountryId) {
						var selectedCountry = this.VDCountryCollection.filter((s) => {
							return s.Id == this.vModelVD.CountryId;
						})[0];
						debugger;
						this.VDPayoutModeList = selectedCountry.PaymentNetworks.filter(
							(x) => x.Id == 3
						)[0].PayoutModes;
						console.log(this.VDPayoutModeList);
						this.$refs.VDPayoutMode.kendoWidget().setDataSource([
							...this.VDPayoutModeList,
						]);
					}
				}, 50);
				this.clearTabFilter();
			},
			onChangeVDPaymentMode(e){
				this.resetStorage();
				this.$refs.VDCurrency.kendoWidget().setDataSource([]);
				setTimeout(() => {
					if (this.vModelVD.PayoutModeId) {
						this.$refs.VDCurrency.kendoWidget().setDataSource(
							this.VDPayoutModeList[0].VDCurrencies
						);
					}else{
						this.vModelVD.SCurrency = 0.0;
						this.vModelVD.ExchangeRate = 0.0;
						this.vModelVD.TransferFee = 0.0;
					}
				}, 50);
			},
			onVDCurrencyChange() {
				setTimeout(() => {
					this.vModelVD.Currency = null;
					this.vModelVD.SCurrency = null;
					if (this.vModelVD.CurrencyId) {
						this.getWuRate();
						this.getRecipientListByFilter("VD",this.vModelVD.CountryId,this.vModelVD.PayoutModeId, this.vModelVD.CurrencyId);
					}else{
						this.resetStorage();
					}
				}, 100);
				var dropDownList = this.$refs.VDCurrency.kendoWidget();
				var selectedVlaue = dropDownList.value();
				this.setCarryModel(this.vModelVD.PaymentNetworkId,this.vModelVD.CountryId, this.vModelVD.PayoutModeId, selectedVlaue);

			},
			onVDPAmountChange(item) {
				let self = this;
				if (item == "transferamount") {
					if (
						isNaN(this.vModelVD.PCurrency) ||
						!this.vModelVD.PCurrency ||
						parseFloat(this.vModelVD.PCurrency) <= 0
					)
						return;
					this.vModelVD.IsLocalCurrencyKeyIn = true;
				} else {
					if (
						isNaN(this.vModelVD.SCurrency) ||
						!this.vModelVD.SCurrency ||
						parseFloat(this.vModelVD.SCurrency) <= 0
					)
						return;
					this.vModelVD.IsLocalCurrencyKeyIn = false;
				}
				setTimeout(() => {
					self.getVdRate();
				}, 1000);

				this.setCarryModelAmount(this.vModelVD.PCurrency,this.vModelVD.SCurrency, this.vModelVD.IsLocalCurrencyKeyIn, this.vModelVD.ExchangeRate);

			},

			clearTabFilter(){
				this.reInitializeVModels();
				this.resetStorage();
			},

			resetStorage(){
				CommonService.removeStorage("carryModel");
				this.RecipientCollection = CommonService.getStorage("RecipientCollection");
			},

			reInitializeVModels : function(){
					this.vModel.RecipientId= null;
					this.vModel.ExchangeRate= null;
					this.vModel.SCurrency= null;
					this.vModel.PCurrency= null;
					this.vModel.Currency= null;
					this.vModel.CurrencyCode= null;
					this.vModel.CountryId= null;
					this.vModel.CurrencyId= null;
					this.vModel.PaymentModeId= null;
					this.vModel.PaymentNetworkId= 1;
					this.vModel.TransferFee= 0.0;
				
					this.vModelWU.CountryId= null;
					this.vModelWU.PayoutModeId= null;
					this.vModelWU.CurrencyId= null;
					this.vModelWU.SCurrency= null;
					this.vModelWU.PCurrency= null;
					this.vModelWU.Currency= null;
					this.vModelWU.ExchangeRate= null;
					this.vModelWU.PaymentNetworkId= 2;
					this.vModelWU.CurrencyCode= "";

					this.vModelVD.CountryId= null;
					this.vModelVD.PayoutModeId= null;
					this.vModelVD.CurrencyId= null;
					this.vModelVD.SCurrency= null;
					this.vModelVD.PCurrency= null;
					this.vModelVD.Currency= null;
					this.vModelVD.ExchangeRate= null;
					this.vModelVD.PaymentNetworkId= 3;
					this.vModelVD.CurrencyCode= "";
			},

			getRecipientListByFilter(paymentNetwork,countryId,payModeId,payoutCurrencyId){
				this.$http.get("recipient/informationbyfilter/" + paymentNetwork + "/" + countryId + "/" + payModeId + "/" + payoutCurrencyId)
					.then(function(response) {
						if(response.status == "200"){
							console.log(response.body);
							this.RecipientCollection = response.body;
						}
					});
			},

			setCarryModelAmount(sendAmount,payAmount, isLocalCurrencyKeyIn, exchangeRate){
				this.CarryModel.SendAmount = sendAmount;
				this.CarryModel.PayAmount = payAmount;
				this.CarryModel.IsLocalCurrencyKeyIn = isLocalCurrencyKeyIn;
				this.CarryModel.ExchangeRate = exchangeRate;
				CommonService.setStorage("carryModel", this.CarryModel);
				console.log(CommonService.getStorage("carryModel"));
			},
			setCarryModel(paymentNetworkId,countryId,payModeId, payoutCurrencyId){
				this.CarryModel.PaymentNetworkId = paymentNetworkId;
				this.CarryModel.CountryId = countryId;
				this.CarryModel.PaymentModeId = payModeId;
				this.CarryModel.PayoutCurrencyId = payoutCurrencyId;
				this.CarryModel.IsStepOne = true;
				CommonService.setStorage("carryModel", this.CarryModel);
				console.log(CommonService.getStorage("carryModel"));
			}
		},
	};
</script>
<style scoped>
</style>
